import React, { useState, useRef, useEffect } from "react";
import Modal from "./Modal";
import { MODAL_CLOSE } from "src/constants/images";
import Spinner from "components/Loader/Spinner";
import { ALERT } from "src/constants/images";
import * as icon from "services/icon";

const warningTransferNFT = ({
  __handleTransferNFT__,
  onClose,
  isVisible,
  toAddressFinal,
  currentName,
  salePrice,
}) => {
  return (
    <Modal
      isVisible={isVisible}
      overlayClass="overlay"
      className="floorPriceWaring card "
    >
      <div className="header px-4 py-3">
        Are you sure?
        <div
          onClick={() => onClose()}
          onKeyPress={(e) => e.code == "Enter" && onClose()}
          className="close-modal"
        >
          <img src={MODAL_CLOSE.SOURCE} alt="close" />
        </div>
      </div>
      <div className="floorPriceWarningBody px-4 py-2">
        <img src={ALERT.SOURCE} />
        <p>
          <p className="text-center">
            You are about to transfer {currentName} to address <br />
            {/* <span className="red"> */}
            {toAddressFinal}
          </p>
          {/* </span>{" "} */}
          <p
            className="text-danger text-center sell-warning"
            style={{ fontSize: "8px !important", marginTop: "15px" }}
          >
            {salePrice > 0 &&
              `This GangstaBet that is listed for sale will be removed from sale automatically while transfering to other wallet.`}
          </p>
        </p>
      </div>
      <div className="mcg-footer px-2 py-2">
        <div className="d-flex">
          <button className="cancel" onClick={() => onClose()}>
            Cancel
          </button>
          <button
            className="complete"
            onClick={() => {
              onClose();
              __handleTransferNFT__(toAddressFinal);
            }}
          >
            Continue
          </button>
          <br />
        </div>
        {/* <p
          className="text-danger text-center sell-warning"
          style={{ fontSize: "8px !important" }}
        >
          {salePrice > 0 &&
            `${currentName} kept on selling will be removed automatically while transfering NFT `}
        </p> */}
      </div>
    </Modal>
  );
};

export default warningTransferNFT;
